<template lang="pug">
  div( @mouseleave="hoverOnGrid(null,null)" )
    a-row.weekday-header(type='flex', justify='space-between', align='stretch')
      a-col.empty-placeholder(:span='1')
        h1 {{ " " }}
      a-col.empty-placeholder(:span='4', v-for='d of weekdays', :key='d')
        transition(name='el-zoom-in-top')
          h1(:style='{opacity: hoverOn.weekday === d || hoverOn.weekday === null ? 1 : .2}', v-show='hoverOn.weekday === d || hoverOn.weekday === null') {{ d }}
        h1(v-show='hoverOn.weekday !== d') {{ " " }}
    div(:title='timeSchedules', :name='timeSchedules', v-for="timeSchedules of ['ABCD','EFGH','IJK']", :key='timeSchedules[0]')
      a-row.timeblock-row(type='flex', justify='space-between', align='stretch', v-for="b of timeSchedules.split('')", :key='b')
        a-col.empty-placeholder(:span='1')
          transition(name='el-zoom-in-center')
            h1(v-show='hoverOn.timeslot === b || hoverOn.timeslot === null') {{ b }}
          h1(v-show='hoverOn.timeslot !== b') {{ " " }}
        a-col.timeblock(:span='4', v-for='d of weekdays', :key='d' @mouseover="hoverOnGrid(d,b)")
          course-grid-rollback( :position="d+b" )
      a-divider(orientation='left') {{ timeSchedules }}
</template>

<script>

import CourseGridRollback from "@/components/Element/CourseGrid/CourseGridRollback";

export default {
  name: "CourseTimetableRollback",
  components: {CourseGridRollback},
  props: ['courses'],
  data() {
    return {
      weekdays: '12345'.split(''),
      timeblock: 'ABCDEFGHIJK'.split(''),
    }
  },
  methods: {
    hoverOnGrid(d, s) {
      this.hoverOn.weekday = d
      this.hoverOn.timeslot = s
    }
  },
  computed: {
    hoverOn: {
      get() {
        return this.$store.state.viewState.hoverCourseGrid
      },
      set(v) {
        this.$store.state.viewState.hoverCourseGrid = v
      }
    }
  }
}
</script>

<style scoped>
.el-row {
}

.timeblock-row {
  min-height: 10px;
  max-height: 9999px;

}

.empty-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
